import React from "react";
import { Control, UseFormWatch } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import TermsAndConditions from "@/components/molecules/RegisterCompanySteps/TermsAndConditions";

interface TermsAndConditionsPanelProps {
  control: Control<RegisterCompanyFormInput>;
  isValid: boolean;
  watch: UseFormWatch<RegisterCompanyFormInput>;
  erroneousSections: string[];
}

const TermsAndConditionsPanel: React.FC<TermsAndConditionsPanelProps> = ({ control, isValid, watch, erroneousSections }) => {
  return (
    <React.Fragment>
      <TermsAndConditions control={control} isValid={isValid} watch={watch} erroneousSections={erroneousSections} />
    </React.Fragment>
  );
};

export default TermsAndConditionsPanel;
